var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLightningBolt = function SvgLightningBolt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4932 7.2733L9.60632 11.0702L6.38956 15.0254C6.14212 15.3418 5.81219 15.5 5.39979 15.5C5.23483 15.5 5.15235 15.5 4.98738 15.4209C4.4925 15.2627 4.16257 14.7881 4.16257 14.3135V10.5956H1.60566C1.11077 10.5956 0.698367 10.3583 0.533405 9.8837C0.368443 9.48818 0.368443 9.01356 0.698367 8.61805L3.83265 4.82111L6.63701 1.02417C6.96693 0.628658 7.46182 0.391349 8.03918 0.549555C8.53407 0.707761 8.86399 1.18238 8.86399 1.657V5.37483H11.5034C11.9983 5.37483 12.4107 5.61214 12.5756 6.00765C12.8231 6.40317 12.7406 6.95689 12.4932 7.2733Z",
    fill: "#666C95"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightningBolt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lightning-bolt.0548a0e8.svg";
export { ForwardRef as ReactComponent };